import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {QschecksControllingFilterPage} from './qschecks-controlling-filter.page';
import {StoreModule} from '@ngrx/store';
import {reducers} from './qschecks-controlling-filter.reducer';
import {EffectsModule} from '@ngrx/effects';
import {QschecksControllingFilterPageUiEffects} from './qschecks-controlling-filter.effects.ui';
import {SopiComponentsModule} from 'src/app/shared/sopi-components/sopi-components.module';
import {SopiScrollModule} from '../../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {QschecksFunktionsbereichePruefplaeneControllingEffects, QschecksPruefplanFilterEffects} from '../../../../client-ngrx/qschecks';

const routes: Routes = [
    {
        path: '',
        component: QschecksControllingFilterPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        StoreModule.forFeature('QschecksControllingFilterPage', reducers),
        EffectsModule.forFeature([
            QschecksControllingFilterPageUiEffects,

            QschecksFunktionsbereichePruefplaeneControllingEffects,
            QschecksPruefplanFilterEffects
        ]),
        SopiScrollModule,
        SopiComponentsModule.forRoot(),
        SopiComponentsModule
    ],
    declarations: [QschecksControllingFilterPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class QschecksControllingFilterPageModule {
    public static forRoot(): ModuleWithProviders<QschecksControllingFilterPageModule> {
        return {
            ngModule: QschecksControllingFilterPageModule,
        };
    }
}
